module.exports = __webpack_public_path__ + "img/arrow.a3bf5159.svg";